const axios = require("axios");
const url = "https://dealersite-server.azurewebsites.net";
//const url = "http://localhost:8080";

export const RequestStatus = Object.freeze({
  Pending: "REQUEST_PENDING",
  Failed: "REQUEST_FAILED",
  Success: "REQUEST_SUCCESS"
});

export const sendLoginRequest = (email, password) => axios.post(`${url}/login`, { email, password });
export const validateLoginToken = token => axios.post(`${url}/validate-login-token`, { token });

export const sendSignupRequest = (dealerNumber, email, password) =>
  axios.post(`${url}/newuser`, { dealer_number: dealerNumber, email, password });

export const sendTokenRequest = email => axios.post(`${url}/request-token`, { email });

export const sendTokenValidationRequest = (token, email) => axios.post(`${url}/is-token`, { token, email });

export const sendNewPasswordRequest = (token, email, password) => axios.post(`${url}/change`, { token, email, password });

export const validatePartRequest = (token, partno) => axios.get(`${url}/parts/${partno}?token=${token}`);

export const submitOrderRequest = (token, parts, pickup, note) =>
  axios.post(`${url}/order/submit`, { token, parts, pickup, note });

export const partSearchRequest = (token, partno) => axios.get(`${url}/parts/dropdown/${partno}?token=${token}`);
